import React from "react"
import { Link } from "react-router-dom"
import { Navigation, Pagination, Autoplay, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import PubSub from "pubsub-js"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import constants from "../../lib/constants"

function HomeContentPic({ contentList, detailLink, requireLogin = false }) {
  const handleClick = (e) => {
    if (requireLogin) {
      e.preventDefault()
      PubSub.publish("REQUIRE_LOGIN", e.target.to)
    }
  }
  return (
    <Swiper
      className="banner-content"
      modules={[Navigation, Pagination, Autoplay, A11y]}
      slidesPerView={1}
      navigation
      speed={800}
      autoplay={{
        delay: detailLink.includes('watch') ? 9000 : 13000,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
    >
      {contentList.map((content) => (
        <SwiperSlide key={content.id}>
          <Link to={`${detailLink}/${content.id}`} onClick={handleClick}>
            <div className="banner-content_pic">
              <img src={`${constants.imageBaseUrl}/product/${content.image}`} alt="" />
            </div>
            <div className="banner-content_text">
              <p>{content.name}</p>
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default HomeContentPic
